import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../Empresas/formulario.css';

import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import PedidoForm from "../Components/PedidoForm/PedidoForm";
import { useAuth } from "../Context/auth";

function NovoPedido() {
    const { currentUser, tenantId } = useAuth(); // <-- ADICIONADO tenantData
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [numeroPedido, setNumeroPedido] = useState(null);
    const [planoTenant, setPlanoTenant] = useState(null); // 1. Adiciona estado para o plano
    const [carregandoDados, setCarregandoDados] = useState(true);

    useEffect(() => {
        if (!currentUser || !tenantId) {
            setCarregandoDados(false);
            return;
        }

        const carregarDadosIniciais = async () => {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;

                // Busca o número do pedido
                const pResponse = await fetch(`${API_URL}/api/pedidos/next-number`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!pResponse.ok) throw new Error('Falha ao gerar número do pedido.');
                const pData = await pResponse.json();
                setNumeroPedido(pData.nextNumber);

                // Busca o contexto do usuário (para o plano)
                const uResponse = await fetch(`${API_URL}/api/user-context`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!uResponse.ok) throw new Error('Falha ao buscar contexto do usuário.');
                const uData = await uResponse.json();
                setPlanoTenant(uData.plano); // Salva o plano

            } catch (error) {
                console.error("Erro ao carregar dados iniciais:", error);
                // Define valores padrão em caso de falha
                setNumeroPedido(Date.now() % 100000);
                setPlanoTenant('Representante'); // Padrão de segurança
            } finally {
                setCarregandoDados(false); // 4. Finaliza o loading
            }
        };

        carregarDadosIniciais();
    }, [currentUser, tenantId]);

    async function handleSalvarPedido(formData) {
        if (!formData.clienteId || formData.itensDoPedido.length === 0) {
            Swal.fire("Erro", "Selecione um cliente e adicione pelo menos um produto.", "error");
            return;
        }
        setLoading(true);

        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/pedidos`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Falha ao salvar pedido.');
            }

            const result = await response.json();
            // CORREÇÃO: Redireciona para a tela de edição
            // Swal.fire("Sucesso!", `Pedido nº ${result.numero} cadastrado com sucesso!`, "success"); // Alert pode ser redundante se o edit mostrar
            navigate(`/app/editarpedido/${result.id}`, { replace: true });

        } catch (error) {
            Swal.fire("Erro", error.message, "error");
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const isReady = !carregandoDados && numeroPedido !== null && tenantId && planoTenant;

    if (!isReady && !tenantId) {
        return (
            <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
                <MenuLateral />
                <div className="content-with-sidebar">
                    <div className="form-card-container">
                        <div className="loading-container"><div className="loading-spinner"></div></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="page-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/pedidos')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="page-title m-0">Novo <span className="highlight">Pedido</span></h1>
                    </div>
                </div>

                <div className="form-card-container">
                    {isReady ? (
                        <PedidoForm
                            key={planoTenant}  // 🔑 idem aqui
                            numeroPedido={numeroPedido}
                            onSubmit={handleSalvarPedido}
                            tenantId={tenantId}
                            isEditing={false}
                            loading={loading}
                            plano={planoTenant}
                        />
                    ) : (
                        <div className="loading-container"><div className="loading-spinner"></div></div>
                    )}

                </div>
            </div>
        </div>
    );
}

export default NovoPedido;